import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createModelCode } from '../model-code/ModelCode';
import { createSimpleUser } from '../user/SimpleUser';

/**
 * # PurchaseList
 *
 * PurchaseList을 설명하세요.
 */
export const PurchaseList = types
  .model('PurchaseList')
  // --------------------------------------------------------------------------
  .props({
    round: types.optional(types.number, 0),
    issueDay: types.maybeNull(types.number),
    goodsCost: types.maybeNull(types.number),
    laborCost: types.maybeNull(types.number),
    projectSid: types.optional(types.number, 0),
    projectTypeCd: createModelCode(),
    purchaseMemo: types.maybeNull(types.string),
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    regUser: types.maybeNull(createSimpleUser()),
    updUser: types.maybeNull(createSimpleUser()),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model purchaseList --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IPurchaseList;
      (Object.keys(newProps) as TPurchaseListKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TPurchaseList = Instance<typeof PurchaseList>;
type TPurchaseListSnapshot = SnapshotOut<typeof PurchaseList>;

export interface IPurchaseList extends TPurchaseList {}
export type TPurchaseListKeys = keyof TPurchaseListSnapshot & string;
export interface IPurchaseListSnapshot extends TPurchaseListSnapshot {}
export const createPurchaseList = () => types.optional(PurchaseList, {} as TPurchaseList);
